import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Select = () => {
  const navigate = useNavigate();
  const [unite, setUnite] = useState(null);
  const [nombre, setNombre] = useState(null);
  const values = [
    "U1",
    "U2",
    "U3",
    "U4",
    "U5",
    "U6",
    "U7",
    "U8",
    "U9",
    "U10",
    "N1",
    "N2",
    "N3",
    "N4",
    "N5",
  ];
  function handleClick(e) {
    let value = e.target.value;
    if (value[0] === "U") {
      value !== unite ? setUnite(value) : setUnite("");
    } else {
      value !== nombre ? setNombre(value) : setNombre("");
    }
  }

  function handleClickGo() {
    if (unite === null || nombre === null) {
      console.log("Il faut choisir des nombres et des unités");
    } else {
      navigate("/" + unite + "/" + nombre);
    }
  }

  const listValues = values.map((item) => (
    <button
      className="border-2 border-slate-500 px-3 mx-3 h-24 hover:bg-slate-200"
      key={item}
      style={item === unite || item === nombre ? { background: "#A9E2F3" } : {}}
      value={item}
      onClick={handleClick}
    >
      {item}
    </button>
  ));
  return (
    <div className="w-full">
      <div className="justify-center items-center flex flex-col gap-y-10">
        <h1 className="text-slate-500 pt-5 text-2xl ">
          Selection des jeux de cartes
        </h1>
        <div className="">{listValues}</div>
        <button
          className="rounded bg-sky-500 p-4 text-white font-bold"
          onClick={handleClickGo}
        >
          Go !
        </button>
      </div>
    </div>
  );
};

export default Select;
